// extracted by mini-css-extract-plugin
module.exports = {"button":"category-button-module--button--PdNXz","image":"category-button-module--image--3xSD8"};